import { useEffect, useRef, useState, Fragment } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { AutoFixHigh, HighlightOff } from '@mui/icons-material';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";
import './chatAI.css';
import ChatInput from './chatInput';
import MessageList from './chatMessage';
import { CommonErrorAlert } from '../../Commonalert/commonErrorAlert';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ChatAIButton = () => {

    const [isChatBox, setIsChatBox] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState(false);
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value;
    const navigate = useNavigate();

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        if (!open) {
            setMessages([]);
        }
        setIsTyping(false);

        setIsChatBox(open);
    };

    const sendMessage = (text) => {
        const userMsg = {
            id: Date.now(),
            role: "user",
            content: text
        };

        setMessages((prev) => [...prev, userMsg]);

        // Simulate assistant reply
        // setTimeout(() => {
        //     const botMsg = {
        //         id: Date.now() + 1,
        //         role: "assistant",
        //         content: "This is a ChatGPT-style response."
        //     };

        //     setMessages((prev) => [...prev, botMsg]);
        // }, 1000);
        // askAssistant(text);
        askAssistantStream(text);
    };

    // const askAssistant = async (question) => {

    //     setIsTyping(true);

    //     try {
    //         const AIResponse = await axios.get(
    // `https://chatbot.elitesiteoptimizer.com/chatbot/query?query=${question}`, {
    //            // `https://chatbot.elitesiteoptimizer.com/chatbot/query_stream?query=${question}`, {
    //             // headers: {
    //             //     Authorization: `${ApiToken}`,
    //             // },
    //         }).catch((error) => {
    //             if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
    //                 setapiOpen(true);
    //                 setapierrorMsg(error?.response?.data?.error)
    //             }
    //             else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
    //                 navigate('/errorpages')
    //             }
    //         });

    //         console.log('AIResponse', AIResponse);
    //         console.log('AIResponse', AIResponse?.data);

    //         if (AIResponse?.data) {
    //             const botMsg = {
    //                 id: Date.now() + 1,
    //                 role: "assistant",
    //                 content: AIResponse.data.response.answer
    //             };
    //             setMessages((prev) => [...prev, botMsg]);
    //             setIsTyping(false);
    //         }

    //     } catch (err) {
    //         console.log('err', err)
    //         setIsTyping(false);
    //     }
    // }

    // Auto-scroll to bottom

    const askAssistantStream = async (question) => {

        setIsTyping(true);

        const assistantMsg = {
            id: Date.now() + 1,
            role: "assistant",
            content: ""
        };
        setMessages((prev) => [...prev, assistantMsg]);

        try {
            const response = await fetch(`https://chatbot.elitesiteoptimizer.com/chatbot/query_stream?query=${question}`);

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let buffer = "";

            while (true) {
                const { value, done } = await reader.read();
                // console.log('value', value, 'done', done);
                if (done) break;

                buffer += decoder.decode(value, { stream: true });

                // Split SSE messages
                const lines = buffer.split("\n\n");
                // console.log('lines', lines);
                buffer = lines.pop(); // keep incomplete chunk

                for (let line of lines) {
                    if (!line.startsWith("data:")) continue;

                    const jsonStr = line.replace("data:", "").trim();
                    if (!jsonStr) continue;

                    try {
                        const data = JSON.parse(jsonStr);

                        if (data.done) {
                            setIsTyping(false);
                            return;
                        }
                        
                        if (data.content) {
                            setMessages((prev) =>
                                prev.map((msg) =>
                                    msg.id === assistantMsg.id
                                        ? { ...msg, content:msg.content + data.content }
                                        : msg
                                )
                            );
                        }
                    } catch (err) {
                        console.error("JSON parse error", err);
                    }
                }
            }

        } catch (err) {
            console.log('err', err)
            setIsTyping(false);
        }
    }

    const list = (anchor) => (
        <Box
            sx={{ width: 300 }}
            role="presentation"
            className="chatAIBox"
        // onClick={toggleDrawer(anchor, false)}
        // onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className="chatAITitle">
                <div className='cancel-chat'>
                    <HighlightOff style={{ cursor: 'pointer', marginBottom: '1rem' }} onClick={toggleDrawer(anchor, false)} />
                </div>
                <span style={{ marginLeft: '1.5rem' }}>Chat with us {' :)'}</span>
            </div>
            <div className="chatAIContent">
                <MessageList messages={messages} isTyping={isTyping} />
            </div>
            <div className="chatAIFooter">
                <div>
                    <ChatInput onSend={sendMessage} />
                </div>
            </div>
        </Box>
    );

    const apihandleClose = () => {
        setapiOpen(false);
    };

    return (
        <div>
            <Fragment key={'right'}>
                {!isChatBox &&
                    <button
                        onClick={toggleDrawer('right', true)}
                        className="chatAIButton"
                    >
                        <AutoFixHigh style={{ color: 'white' }} />
                    </button>
                }
                <Drawer
                    className='aichat-drawer'
                    anchor={'right'}
                    open={isChatBox}
                    onClose={toggleDrawer('right', false)}
                    // sx={{backgroundColor:'transparent'}}
                >
                    {list('right')}
                </Drawer>
            </Fragment>

            <CommonErrorAlert
                data={{
                    apiopen: apiopen,
                    apiErrorMsg: apierrorMsg,
                    isIconStyled: true
                }}
                closeAlert={apihandleClose} />
        </div>
    );
};

export default ChatAIButton;
